import React from 'react';
import {
    Card,
    CardHeader,
    Row,
    Col,
  } from "reactstrap";
import { Spinner } from './Icons/Spinner'
export const LoadingPage = ( props ) =>  {
      let {
       title = "Cargando datos"
    } = props;
    
        return (
<>
    <div className="content">
    <br /><br /><br /><br /><br /><br />
    
            <Row>
            <Col className="col-md-4 ml-auto mr-auto">
              <Card>
                <CardHeader>
                  <Row>
                    <Col sm="12">
                      <Spinner className="pull-right h3"/> 
                      <div className="numbers">{title}</div>
                    </Col>
                  </Row>
                </CardHeader>
               
              </Card>
            </Col>
        </Row>
    </div>
</>
        ); 
}
